import React from 'react';
import FeatureToggleUtils from 'FeatureToggleUtils';
import { WebcastingWrapper as WebcastingWrapperPlayer } from '@bizzabo/broadcast';

function WebcastingWrapper({url, onLoad}) {
    const isStreamCommonEnabled = FeatureToggleUtils.isFeatureEnabled('broadcastPlayerStream');

    return (
        <>
            {
                isStreamCommonEnabled ?
                    <WebcastingWrapperPlayer
                        src={url}
                        onLoad={onLoad}
                    /> :
                    <iframe
                        src={url}
                        frameBorder='0'
                        width='100%'
                        height='501px'
                        onLoad={onLoad}
                    />
            }
        </>
    );
}

export default React.memo(WebcastingWrapper);
